import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Bed, Bath, Ruler } from "lucide-react";

export const formatPrice = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n || 0);

export const ListingCard = ({ l }) => {
  const isConfidential = l.category === "dental" || l.category === "medical";
  return (
    <Link
      to={`/listings/${l.id}`}
      className="group block bg-white border border-slate-200 overflow-hidden hover:shadow-luxury-lg transition-shadow duration-500"
      data-testid={`listing-card-${l.id}`}
    >
      <div className="aspect-[4/3] overflow-hidden bg-slate-100 relative">
        <img
          src={l.images?.[0] || "https://images.unsplash.com/photo-1706808849827-7366c098b317?crop=entropy&cs=srgb&fm=jpg&q=85"}
          alt={l.title}
          className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-700"
          loading="lazy"
        />
        <div className="absolute top-4 left-4">
          <span className="bg-navy text-white text-[10px] uppercase tracking-[0.2em] px-3 py-1.5">{l.category}</span>
        </div>
        {l.status !== "active" && (
          <div className="absolute top-4 right-4">
            <span className="bg-gold text-navy text-[10px] uppercase tracking-[0.2em] px-3 py-1.5 font-semibold">{l.status}</span>
          </div>
        )}
      </div>
      <div className="p-6">
        <div className="overline text-gold">{l.location}</div>
        <h3 className="font-display text-xl text-navy mt-2 group-hover:text-gold transition-colors">{l.title}</h3>
        <div className="mt-4 flex items-center justify-between">
          <div className="font-display text-2xl text-navy">{formatPrice(l.price)}</div>
        </div>
        <div className="mt-4 pt-4 border-t border-slate-200 flex items-center gap-4 text-xs text-slate-500">
          {!isConfidential && l.bedrooms > 0 && (<span className="inline-flex items-center gap-1"><Bed className="w-3.5 h-3.5" />{l.bedrooms} bd</span>)}
          {!isConfidential && l.bathrooms > 0 && (<span className="inline-flex items-center gap-1"><Bath className="w-3.5 h-3.5" />{l.bathrooms} ba</span>)}
          {l.sqft > 0 && (<span className="inline-flex items-center gap-1"><Ruler className="w-3.5 h-3.5" />{l.sqft.toLocaleString()} sqft</span>)}
          <span className="inline-flex items-center gap-1 ml-auto"><MapPin className="w-3.5 h-3.5" />{(l.location || "").split(",")[0]}</span>
        </div>
      </div>
    </Link>
  );
};
